import React from 'react';
import { Input } from 'components/UI/V3/Forms/Input/Input';
import { Textarea } from 'components/UI/V3/Forms/Textarea/Textarea';
import styles from './EvaluationBasicInfo.module.scss';
import { FieldError } from '@spike/model';
import { getErrorMessage } from './Validations';

interface EvaluationBasicInfoProps {
    evaluationName: string;
    description: string;
    errors: Array<FieldError>;
    onUpdateName: (name: string) => void;
    onUpdateDescription: (description: string) => void;
}

export const EvaluationBasicInfo: React.FC<EvaluationBasicInfoProps> = ({
    evaluationName,
    description,
    errors,
    onUpdateName,
    onUpdateDescription
}) => {
    return (
        <>
            <div className={styles.section}>
                <Input
                    label="Evaluation Name"
                    value={evaluationName}
                    onChange={e => onUpdateName(e.target.value)}
                    placeholder="Ex. Evaluation"
                    error={getErrorMessage(errors, 'name')}
                    required
                />
            </div>

            <div className={styles.section}>
                <Textarea
                    label="Write a Short Description"
                    value={description}
                    onChange={e => onUpdateDescription(e.target.value)}
                    maxLength={400}
                    rows={3}
                />
            </div>
        </>
    );
};

export default EvaluationBasicInfo;
